import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

// Basado en la captura de pantalla de Django REST Framework
export const baseURI = 'nominas/percepciones-plazas';

/**
 * GET Percepciones Plazas
 * @param {object} params - Usualmente { percepcion: id }
 * @returns {Promise<object[]>}
 */
export const getPercepcionesPlazas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Percepcion Plaza individual
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getPercepcionPlaza = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Percepcion Plaza
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postPercepcionPlaza = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Percepcion Plaza
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchPercepcionPlaza = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Percepcion Plaza
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deletePercepcionPlaza = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * POST eliminación masiva de Percepcion Plaza en background (Celery).
 * Evita disparar un DELETE HTTP por cada fila seleccionada -- con selecciones grandes
 * (p.ej. "seleccionar todos") eso satura al servidor. Responde 202 con { task_id,
 * descripcion_proceso }; el avance se consulta con getProcesoEnCursoTerminado.
 * @param {number} percepcionId
 * @param {number[]} ids
 * @returns {Promise<{task_id: string, descripcion_proceso: string}|null>}
 */
export const deletePercepcionesPlazaBulk = async (percepcionId, ids) => {
  try {
    const response = await API.post(
      `nominas/percepciones-importe-plaza-eliminar-bulk/${percepcionId}/`,
      { ids },
    );
    return response.data;
  } catch (err) {
    onError(err);
    return null;
  }
};
